import React from "react";
import { connect } from "react-redux";
import Basic from "./add_form/Basic";
import Limits from "./add_form/Limits";
import Advanced from "./add_form/Advanced";
import Security from "./add_form/Security";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import { t } from "i18next";
import Stepper from "Components/stepper2/Stepper";
import Loader from "Components/loader/Loader";

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

const formInitialState = {
  name: "",
  password: "",
  password_confirmation: "",
  firstname: "",
  lastname: "",
  default_quota: 8589934592,
  pop_disabled: false,
  imap_disabled: false,
  smtp_disabled: false,
  webmail_disabled: false,
  forwards: [],
  keep_copy: false,
  bounce_mail: false,
  password_change_disabled: false,
  allow_nets: [],
  password_expiration: -1,
  force_new_password: false,
  block_old_password: false,
  password_recovery_disabled: false,
  force_otp: false,
  apply_allow_nets_webmail: false,
  api_enabled: false,
  dav: true,
  activesync: true,
  role: "",
  organizational_unit: "",
  mobilephone: "",
  destroy_sessions_on_password_expiration: false,
};

class EmailAccountNewScreen extends React.Component {
  constructor(props) {
    super(props);

    if (!props.domain.name) {
      this.props.getDomain();
    }

    this.state = {
      currentStep: 1,
      steps: {
        1: { component: <Basic /> },
        2: { component: <Limits /> },
        3: { component: <Security /> },
        4: { component: <Advanced /> },
      },
      domainCode: this.props.match.params.domainCode,
    };
  }

  componentDidMount() {
    const { domain } = this.props;

    if (domain.name) {
      this.setDomainValues();
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  componentDidUpdate(prevProps) {
    const { domain } = this.props;

    if (!prevProps.domain.name && domain.name) {
      this.setDomainValues();
    }
  }

  setDomainValues = () => {
    const { domain, setFormFieldValue } = this.props;

    setFormFieldValue({
      imap_disabled: domain.imap_disabled,
      smtp_disabled: domain.smtp_disabled,
      webmail_disabled: domain.webmail_disabled,
      pop_disabled: domain.pop_disabled,
      max_email_quota: domain.default_quota,
      force_new_password: domain.force_password_first_login,
      password_change_disabled: domain.password_change_disabled,
      password_recovery_disabled: domain.password_recovery_disabled,
      // addressbook data
      telephone: domain.addressbook_data.telephone,
      address: domain.addressbook_data.address,
      city: domain.addressbook_data.city,
      company: domain.addressbook_data.company,
      state: domain.addressbook_data.state,
      country: domain.addressbook_data.country,
      zip: domain.addressbook_data.zip,
      destroy_sessions_on_password_expiration: domain.destroy_sessions_on_password_expiration,
      password_expiration: domain.password_expiration,
    });
  };

  goToStep = (no) => {
    this.setState({ currentStep: no });
  };

  showStepNumber = (no) => {
    return this.state.steps[no];
  };

  submitForm = () => {
    const { setFormLoading, unsetFormLoading, setFormErrors, refreshDomain, domain } = this.props;
    const data = Object.assign({}, this.props.formData);
    setFormLoading();
    const api = new QboxmailApi({ useCookie: true });
    if (data.forwards && data.forwards.length === 0) delete data.forwards;
    if (this.context.isLoggedUserAdmin()) data.customer_code = this.props.match.params.customerCode;
    api
      .createEmailAccount(domain.code, data)
      .then(() => {
        refreshDomain();
        this.returnToList();
        alertSuccess(t("alert.emailCreatedSuccess"));
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          setFormErrors(errors);
          unsetFormLoading();
        });
      });
  };

  returnToList = () => {
    const {
      match: { params },
    } = this.props;
    let url = `/domains/${params.domainCode}/email_accounts`;

    const loggedUser = this.context.getLoggedUser();

    if (loggedUser.type === "Admin") {
      url = `/customers/${params.customerCode}${url}`;
    } else if (loggedUser.type === "Postmaster") {
      url = "/";
    }

    this.props.history.push({
      pathname: url,
    });
  };

  resetAndGoBack = () => {
    this.props.resetForm();
    this.returnToList();
  };

  prevStep = () => {
    if (this.state.currentStep <= 1) return;
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  render() {
    const { isDomainLoading, domain } = this.props;
    let toShow = this.showStepNumber(this.state.currentStep);

    if (isDomainLoading || !domain.name) {
      return <Loader {...this.props} />;
    }

    return (
      <div className="contentWrapper">
        {React.cloneElement(toShow.component, {
          ...this.props,
          backToList: this.resetAndGoBack,
          goToStep: this.goToStep,
          submitForm: this.submitForm,
          onSuccess: () => this.onSuccess(),
          isloggedUserInTrial: this.context.isLoggedUserTrial(),
          isLoggedUserAdmin: this.context.isLoggedUserAdmin(),
          stepper: <Stepper steps={4} active={this.state.currentStep} goBack={this.prevStep} />,
        })}
      </div>
    );
  }
}

//EmailAccountNewScreen.propTypes = propTypes;
EmailAccountNewScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data.0", state),
  isDomainLoading: resActions.isResourceLoading("domain", state),
});

const mapDispatchToProps = (dispatch, props) => {
  const domainCode = props.match.params.domainCode || props.loggedUser.domain_code;

  return {
    getDomain: () => dispatch(resActions.callApi("refreshDomain", "domain", domainCode)),
    refreshDomain: () => dispatch(resActions.callApi("refreshDomain", "domain", domainCode)),
    refreshEmailAccounts: (domainCode) =>
      dispatch(resActions.callApi("refreshEmailAccounts", "emailAccounts", domainCode, queryParams)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(EmailAccountNewScreen, formInitialState));
